/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import { v4 as uuid } from 'uuid';
import { FORGE_SAMPLING_RATE } from '../../../constants.tsx';
import {
	cancelConcurrentWorkItemExperience,
	forgeModulesConcurrentFetchTime,
	startConcurrentWorkItemExperience,
	stopConcurrentWorkItemExperience,
} from '../performance-analytics/main.tsx';

type MeasureExecutionTimeMetricsOptions = {
	ufoExperienceKey?: string;
};

export const measureExecutionTimeMetrics = async <T,>(
	action: () => Promise<T>,
	options?: MeasureExecutionTimeMetricsOptions,
): Promise<T> => {
	const concurrentId = uuid();
	const shouldSendTimeMetric = Math.random() * 100 < FORGE_SAMPLING_RATE;
	const metric = forgeModulesConcurrentFetchTime(concurrentId);

	try {
		if (shouldSendTimeMetric) {
			if (options?.ufoExperienceKey != null) {
				startConcurrentWorkItemExperience(concurrentId, options.ufoExperienceKey, {
					startTime: performance.now(),
				});
			} else {
				metric.start({ startTime: performance.now() });
			}
		}
		const result = await action();

		if (shouldSendTimeMetric) {
			if (options?.ufoExperienceKey != null) {
				stopConcurrentWorkItemExperience(concurrentId, options.ufoExperienceKey, {
					stopTime: performance.now(),
				});
			} else {
				metric.stop({ stopTime: performance.now() });
			}
		}
		return result;
	} catch (error) {
		if (shouldSendTimeMetric) {
			if (options?.ufoExperienceKey != null) {
				cancelConcurrentWorkItemExperience(concurrentId, options.ufoExperienceKey);
			} else {
				metric.cancel();
			}
		}
		throw error;
	}
};
